<template>
<div class="popup" v-if="notificationsShow" style="position:fixed">
        <div class="notifiy-content" id="notifications" v-show="contentShow" style="position:fixed">
            <div class="title">
                {{$t('language.rightTopBanner.notification')}}
                <div class="icon white-close dialog-close" id="dialogClose" @click="close()"></div>
            </div>
            <div class="notification-content">
                <div id="notificationContainer" v-html="$t('language.popup.addCloudPopup.notificationTip')">
                </div><br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.8.5</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2026/5/31</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v885')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.8.4</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2026/4/30</div>
                    <b>{{$t('language.popup.addCloudPopup.improvedLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v884')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.8.1</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2026/1/19</div>
                    <b>{{$t('language.popup.addCloudPopup.improvedLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v881')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.8.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/12/31</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v880')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.7.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/10/31</div>
                    <b>{{$t('language.popup.addCloudPopup.improvedLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v870')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.3.1</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/5/30</div>
                    <b>{{$t('language.popup.addCloudPopup.noteLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v831')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}8.3.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/3/15</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v830')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.8.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/2/28</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v780')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.6.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/2/24</div>
                    <b>{{$t('language.popup.addCloudPopup.improvedLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v760')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.5.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2025/1/15</div>
                    <b>{{$t('language.popup.addCloudPopup.improvedLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v750')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.4.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/12/31</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b><br>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v740')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.3.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/12/27</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b><br>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v730')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.2.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/11/08</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v720')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.1.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/06/27</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v710')"></div>
                </div>
                <br>
                <b>{{$t('language.popup.addCloudPopup.notAbleAccess')}}</b>
                <div>{{$t('language.popup.addCloudPopup.problemNotAccess')}}</div><br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}7.0.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/05/09</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v700')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}6.3.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/02/29</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v630')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}6.2.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2024/01/30</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v620')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.5.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2023/09/11</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v550')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.3.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2023/06/30</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v530')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.2.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2023/05/31</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v520')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}5.0.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2023/03/15</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v500')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.9.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2023/02/14</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v490')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.7</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2022/07/07</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v487')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.5</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2022/06/08</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v485')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.2</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2022/05/30</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v482')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.8.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2022/01/20</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v480')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.7.0</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2021/11/05</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v470')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.6.8</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2021/09/30</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v468')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.6.7</b>
                    <div>{{$t('language.popup.addCloudPopup.releasedOn')}}2021/07/01</div>
                    <b>{{$t('language.popup.addCloudPopup.newLabel')}}</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v467')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.6.5</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v465')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.7</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v457')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.6</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v456')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.5</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v455')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.4</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v454')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.3</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v453')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.2</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v452')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.1</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v451')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.5.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v450')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.4</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v444')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.3</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v443')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.2</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v442')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.1</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v441')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.4.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v440')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.3.1</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v431')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.3.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v430')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.2.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v420')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.1.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v410')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}4.0.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v400')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.8.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v380')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.7.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v370')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.6.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v360')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.5.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v350')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.4.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v340')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.3.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v330')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.2.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v320')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.1.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v310')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}3.0.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v300')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.3.1</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v231')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.3.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v230')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.2.2</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v222')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.2.1</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v221')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.2.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v220')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.1.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v210')"></div>
                </div>
                <br>
                <div>
                    <b>{{$t('language.popup.addCloudPopup.version')}}2.0.0</b>
                    <div v-html="$t('language.popup.addCloudPopup.notif_v200')"></div>
                </div>
                <br>
            </div>
            <div class="notificate-footer">
                <div style="float:left;position:relative;top:8Px;line-height:30Px;"  @click.stop="checkBox()">
                <span id="checkIcon" class="icon-util  notification-check-position" :class="check?'check-small':'nocheck-small'" @click.stop="checkBox()"></span>
                <span class="notice-text">{{$t('language.popup.addCloudPopup.noPrompt')}}</span>
                </div>
                <button style="float:right;margin-right:10Px;width:110Px;position:relative;top:8Px;"   @click="sure()">{{$t('language.popup.addCloudPopup.okButton')}}</button>
            </div>
        </div>
</div>
</template>

<script>
import commonUtils from "@/js/workspace/common_util.js";
export default {
    data: function () {
        return {
            notificationsShow: false,
            contentShow: false,
            check: false,
            versions: [],
            timejson:null
        }
    },
    created() {

    },
    methods: {
        sure(){
         let user = commonUtils.getUser();
         this.$cookies.set("check"+user.id,this.check, "1y");   
         this.close();
        },
        getTxtInfo(value){
   if (!value) return '';
      let str1=value.substr(value.indexOf(":")+1,value.length);
     // let strFirst=str1.substr(0,str1.indexOf(":"));
      let str=str1.substr(str1.indexOf(":")+1,str1.length);
    //   console.log(strFirst);
    //   console.log(str1);
    //   let strInfo={
    //    first:strFirst,
    //    info:str
    //   }
      if(str.indexOf(':')!=-1){
         var args = str.split(':');
        // console.log(args);
         str =args[0]+'<br>'+args[1];  
      }
     // console.log(str);
      return str;
        },
        close() {
        //目标div的offset
            this.$parent.newNotifyShow=false;
            this.notificationsShow = false;
            this.$parent.letPassWordShow = false;
            this.$parent.showPassWord();
            this.$parent.letTimeSalePassWordShow = false;
            commonUtils.updateViewTime();
        },
   checkBox(){
            this.check=!this.check;
    },
    },
     filters: {
    getInfo (value) {
      if (!value) return '';
      let str1=value.substr(value.indexOf(":")+1,value.length);
     // let strFirst=str1.substr(0,str1.indexOf(":"));
      let str=str1.substr(str1.indexOf(":")+1,str1.length);
    //   console.log(strFirst);
    //   console.log(str1);
    //   let strInfo={
    //    first:strFirst,
    //    info:str
    //   }
      if(str.indexOf(':')!=-1){
         var args = str.split(':');
         //console.log(args);
         str =args[0]+'\t'+args[1];  
      }
      //console.log(str);
      return str;
    },

  }
}
</script>

<style>
#notifications {
    width: 500px;
    /*no*/
    height: 500px;
    /*no*/
}

.notification-content {
    width: 100%;
    height: 380px;
    /*no*/
    box-sizing: border-box;
    padding: 0px 10px 0 20px;
    /*no*/
    overflow: auto;
    font-size: 13px;
    /*no*/
    color: #595959;
    line-height: 20px;
    /*no*/
    margin-top: 20Px;
}

.notification-content::-webkit-scrollbar {
    width: 8px;
    /*no*/
    height: 0px;
    /*no*/
    background-color: #fff;
}

.notification-content::-webkit-scrollbar-thumb {
    height: 1px;
    /*no*/
    border-radius: 5px;
    /*no*/
    background-color: #becae4;
}

.notificate-footer {
    width: 100%;
    height: 20px;
    /*no*/
    float: left;
}

.notice-text {
    font-size: 14px;
    /*no*/
    color: #858585;
    position: relative;
    left: 10Px;
}

.notification-check-position {
    position: relative;
    left: 10px;
    /*no*/
    top: 3px;
    /*no*/
    cursor: pointer;
}
/* 
.bounce-enter-active {
    transform-origin: 76% 10%;
}

.bounce-leave-active {
    transform-origin: 122% -23%;
    animation: bounce-in 1.2s reverse;
}

@keyframes bounce-in {
    0% {
        transform: scale(0);
    }
  
    50% {
        transform: scale(0.6, 0.8);
    }
    

    80% {
        transform: scale(0.7, 1);
    }


    100% {
        transform: scale(0.8, 1);
    }

    font {
        transform: scale(1, 1);
    }
} */

.notifiy-content {
    box-sizing: border-box;
    border: 1px solid #8a96e3;
    /*no*/
    background-color: #fff;
    position: absolute;
    margin: auto;
    z-index: 700;
    bottom: 0;
    /*no*/
    right: 0;
    left: 0;
    top: 0;
}

#notifications .font {
    transform: scale(1);
}

.imagesaver_versions {
    padding-left: 10px;
    margin: 0px;
}

.imagesaver_version {
    padding-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/personal_center_popups/notifications_popup.vue